import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngstack/translate';
import { SubsidiaryCompanyAgentEntryComponent } from '../subsidiary-company-agent-entry/subsidiary-company-agent-entry.component';
import { SubsidiaryCompanyAgentService } from 'src/app/services/http/business/subsidiary/subsidiary-company-agent.service';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';

@Component({
  selector: 'app-subsidiary-company-agent-list',
  templateUrl: './subsidiary-company-agent-list.component.html',
  styleUrls: ['./subsidiary-company-agent-list.component.css']
})
export class SubsidiaryCompanyAgentListComponent implements OnInit {
  filter:any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "AgentName",
    "NationalCode",
    "RoleName",
    "StartDate",
    "EndDate",
    "PhoneNumber",
    "function"

  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  queryParams:any;
  customer: any;

  constructor(
    private route: ActivatedRoute,
       private dialog: MatDialog,
       public translate: TranslateService,
       private subsidiaryCompanyAgentService: SubsidiaryCompanyAgentService,
       private subsidiaryCompanyService: SubsidiaryCompanyService
    ) {
 }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
        this.filter=params["params"];
    });
    this.getCustomerById();
    this.refresh();
  }
  getCustomerById() {
    let queryParams={
      Id:this.filter.CustomerId
    };
    this.subsidiaryCompanyService.getCustomerList(queryParams).subscribe(
      res => {
        this.customer = res.DataList[0];
      }
    );
  }
  refresh() {
    this.subsidiaryCompanyAgentService.getCustomerAgentList(this.filter).subscribe(
      res => {

        this.paginator.pageSize = 10;
        this.paginator.length = res.Total;
        this.pageIndex = 0;
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  paginatorEvent(event) {
    this.subsidiaryCompanyAgentService.getCustomerAgentList(this.filter,event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  addAgent() {

    this.dialog
      .open(SubsidiaryCompanyAgentEntryComponent, {
        width: "500px",
        data: this.filter
      })
      .afterClosed()
      .subscribe(() => {
        this.subsidiaryCompanyAgentService.getCustomerAgentList(this.filter).subscribe(
          res => {
    
            this.paginator.pageSize = 10;
            this.paginator.length = res.Total;
            this.pageIndex = 0;
            this.paginator.length = res.Total;
            this.dataSource = new MatTableDataSource(res.DataList);
          }
        );
      });
  }
  editAgent(params: any) {

      this.dialog.open(SubsidiaryCompanyAgentEntryComponent, {
          width: "500px",
          data: params
        })
        .afterClosed()
        .subscribe(() => {
           this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
        });
  }

}
